import { Team } from '../../domain/models';

export interface TeamEntity {
  id: string;
  name: string;
  description: string | null;
  logo_url: string | null;
  is_public: boolean;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export const teamEntityToModel = (entity: TeamEntity): Team => ({
  id: entity.id,
  name: entity.name,
  description: entity.description || undefined,
  logoUrl: entity.logo_url || undefined,
  isPublic: entity.is_public ?? false,
  userId: entity.user_id,
  createdAt: new Date(entity.created_at),
  updatedAt: new Date(entity.updated_at),
});

export const teamModelToEntity = (model: Partial<Team>): Partial<TeamEntity> => ({
  ...(model.name !== undefined && { name: model.name }),
  ...(model.description !== undefined && { description: model.description || null }),
  ...(model.logoUrl !== undefined && { logo_url: model.logoUrl || null }),
  ...(model.isPublic !== undefined && { is_public: model.isPublic }),
  ...(model.userId !== undefined && { user_id: model.userId }),
});
